export default __webpack_public_path__ + "static/media/user.4f73ac9c.svg";